import React from 'react';
import { List } from 'antd';
import SummaryCard from './SummaryCard';
import ActivityItem from '@/components/ProjectDetails/Cards/Items/ActivityItem';
import { LeadActivityModel } from '@/typings/models/LeadActivity';
import { F } from '@/utils/intl';

export interface ActivitiesCardProps {
  activities: LeadActivityModel[];
  count: number;
  onShowAll?: () => void;
}

const ActivitiesCard: React.FC<ActivitiesCardProps> = ({
  activities,
  count,
  onShowAll,
}) => {
  return (
    <SummaryCard
      title={<F id={'entity.activity.plural'} defaultMessage={'Activities'}/>}
      count={count}
      onShowAll={onShowAll}
    >
      <List
        dataSource={activities}
        renderItem={(activity) => <ActivityItem onActivityItemClick={onShowAll} activity={activity}/>}
      />
    </SummaryCard>
  );
};

export default ActivitiesCard;
